import { getConfigFromFile, getDataFromLocalStorage } from '../utils/methods';
import { menus } from './menu';
import { IConfig } from '../utils/interface';

export type TPermission = 'Accounts' | 'Limits' | 'Cards' | 'PersonalAccounts' | 'Holders' | 'Reports' | 'Attributes' | 'Driver' | 'Transfers' | 'All' | 'Config';

interface IPermission {
  permissionId: string;
  permissionName: TPermission;
  permissionValue: access;
}

export interface ICheckPermission {
  permissionName: TPermission;
  notShowPermission?: TPermission;
  configFile?: IConfig;
}

enum access { 'notAccess', 'write', 'read'}

const getConfig = () => {
  return new Promise(async (resolve) => {
    resolve(await getConfigFromFile());
  });
};

export function checkPermission({ permissionName, notShowPermission, configFile }: ICheckPermission): access {

  let perms: IPermission[] = JSON.parse(getDataFromLocalStorage('permissions') as string);

  const resNotShow = perms.find(perm => perm.permissionName === notShowPermission);

  /* Если есть условие не отображать этой роли */
  if (resNotShow) {
    return 0;
  }
  //else {      if (permissionName === 'All') return 2;    }

  /* Если стоит условие отображать для всех и нет условия не отображать */
  if (permissionName === 'All' && notShowPermission === undefined) return 2;

  /* Если стоит условие отображать у всех */
  if (permissionName === 'All') return 2;

  /* Проверка отображения через конфигурационный файл, если есть условие */
  if (permissionName === 'Config' && configFile) {
    if (!!configFile.config.bills) return 2;
  }


  const resAccess = perms.find(perm => perm.permissionName === permissionName);

  let resValue: number = 0;
  switch (resAccess?.permissionValue) {
    case access.read: {
      resValue = 1;
      break;
    }
    case access.write: {
      resValue = 2;
      break;
    }
    default : {
      resValue = 0;
      break;
    }
  }

  return resValue;
}

export function getPermissionLinks({ permissionName }: ICheckPermission) {
  return menus.filter(menu => !!menu.icon && menu.permission && checkPermission({ permissionName: menu.permission }) > 0);
}
